import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a483c990")

_pushScopeId("data-v-a483c990")
const _hoisted_1 = { "data-testid": "modal-select-client-schedule" }
const _hoisted_2 = { class: "w-full font-semibold text-20px text-center" }
const _hoisted_3 = { class: "pb-4 flex flex-col gap-y-4 w-full" }
const _hoisted_4 = { class: "grid grid-cols-2 w-full gap-4" }
const _hoisted_5 = { class: "col-span-1" }
const _hoisted_6 = { class: "col-span-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ModalV2, {
      isCustomTitle: "",
      onClose: _ctx.onClose,
      width: "w-500px",
      showBorderTitle: false,
      contentPadding: 'px-6 pt-3 pb-0',
      footerPadding: 'px-6 py-4',
      marginHeader: 'mb-0',
      marginFooter: 'mt-0',
      isShadows: false,
      isRoundedLg: true,
      showFooter: true,
      footerBgColor: 'bg-white',
      borderTop: '',
      closeButtonTestId: "modal-select-client-schedule-button-close"
    }, {
      "custom-title": _withId(() => [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pickup.scheduleConfig.clientSelector.clientPlaceholder')), 1)
      ]),
      content: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            label: '',
            class: "w-full"
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                placeholder: 
                _ctx.$t('pickup.scheduleConfig.clientSelector.clientPlaceholder')
              ,
                class: "mt-2",
                keyName: "clientName",
                keyValue: "clientId",
                "model-value": _ctx.selectedClient || '',
                options: _ctx.clientOptions,
                "is-loading": _ctx.clientSearchLoading,
                "max-height": "300px",
                maxLength: 1000,
                useInfiniteScroll: "",
                onFocus: _ctx.onClientSearchFocus,
                onFilter: _ctx.onClientSearchFilter,
                onScrolled: _ctx.onClientSearchScrolled,
                onChange: _ctx.onClientSelect
              }, null, 8, ["placeholder", "model-value", "options", "is-loading", "onFocus", "onFilter", "onScrolled", "onChange"])
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_LpButton, {
              "data-testid": "modal-select-client-schedule-button-cancel",
              title: _ctx.$t('pickup.scheduleConfig.clientSelector.cancel'),
              color: "red-lp-2400",
              textColor: "red-lp-2400",
              isWidthFull: "",
              outline: "",
              onClick: _ctx.onClose
            }, null, 8, ["title", "onClick"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_LpButton, {
              "data-testid": "modal-select-client-schedule-button-continue",
              title: _ctx.$t('pickup.scheduleConfig.clientSelector.continue'),
              color: "red-lp-2400",
              textColor: "white",
              isWidthFull: "",
              disabled: !_ctx.selectedClient,
              onClick: _ctx.onContinue
            }, null, 8, ["title", "disabled", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onClose"])
  ]))
})